"use client";

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/shared/ui/select";
import { useTransition } from "react";
import { setUserLocale } from "@/shared/lib/i18n";
import { useLocale } from "next-intl";
import type { Locale } from "@/shared/config/i18n";

export function AdminLocaleSwitcher() {
  const [isPending, startTransition] = useTransition();
  const locale = useLocale();

  const onChangeLocale = (value: string) => {
    startTransition(() => {
      setUserLocale(value as Locale);
    });
  };

  return (
    <Select value={locale} onValueChange={onChangeLocale} disabled={isPending}>
      <SelectTrigger className="border-gray-300 bg-white text-sm text-gray-600 focus:ring-blue-500">
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="w-16">
        <SelectGroup>
          <SelectLabel>Language</SelectLabel>
          <SelectItem value="ko">KR</SelectItem>
          <SelectItem value="en">EN</SelectItem>
          <SelectItem value="pt">POR</SelectItem>
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
